var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardPersonalDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Account/Personal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -1.77635684e-15 24.9998 -1.77635684e-15 24.9998 15.202 0 15.202"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 25 0 25 15.2275 0 15.2275"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Account/Personal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000200, 9.798000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.449,15.202 L4.551,15.202 C2.041,15.202 0,13.161 0,10.651 L0,1 C0,0.447 0.447,-1.77635684e-15 1,-1.77635684e-15 C1.553,-1.77635684e-15 2,0.447 2,1 L2,10.651 C2,12.057 3.144,13.202 4.551,13.202 L20.449,13.202 C21.855,13.202 23,12.057 23,10.651 L23,9.547 C23,8.994 23.447,8.547 24,8.547 C24.553,8.547 25,8.994 25,9.547 L25,10.651 C25,13.161 22.959,15.202 20.449,15.202",
    id: "Fill-1",
    fill: "#282827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,15.2275 C23.447,15.2275 23,14.7805 23,14.2275 L23,4.5505 C23,3.1445 21.855,1.9995 20.449,1.9995 L4.551,1.9995 C3.145,1.9995 2,3.1445 2,4.5505 L2,5.6885 C2,6.2415 1.553,6.6885 1,6.6885 C0.447,6.6885 0,6.2415 0,5.6885 L0,4.5505 C0,2.0405 2.041,-0.0005 4.551,-0.0005 L20.449,-0.0005 C22.959,-0.0005 25,2.0405 25,4.5505 L25,14.2275 C25,14.7805 24.553,15.2275 24,15.2275",
    id: "Fill-4",
    fill: "#282827"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.9481,9.2629 L14.8421,9.2629 C14.1351,9.2629 13.5641,9.8219 13.5641,10.5119 C13.5641,11.2019 14.1351,11.7609 14.8421,11.7609 L18.9481,11.7609 C19.6541,11.7609 20.2261,11.2019 20.2261,10.5119 C20.2261,9.8219 19.6541,9.2629 18.9481,9.2629",
    id: "Fill-7",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9481,13.24 L14.8421,13.24 C14.1351,13.24 13.5641,13.799 13.5641,14.489 C13.5641,15.179 14.1351,15.738 14.8421,15.738 L18.9481,15.738 C19.6541,15.738 20.2261,15.179 20.2261,14.489 C20.2261,13.799 19.6541,13.24 18.9481,13.24",
    id: "Fill-9",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3914,12.4888 C9.4314,12.2378 10.1714,11.2178 9.9704,10.0628 C9.8234,9.2238 9.1564,8.5388 8.3204,8.3758 C6.9704,8.1128 5.7884,9.1398 5.7884,10.4428 C5.7884,11.4348 6.4754,12.2658 7.4004,12.4888 C5.9114,12.7268 4.7734,14.0128 4.7734,15.5678 L4.7734,15.6208 C4.7734,16.1978 5.2414,16.6658 5.8184,16.6658 L9.9734,16.6658 C10.5504,16.6658 11.0184,16.1978 11.0184,15.6208 L11.0184,15.5678 C11.0184,14.0128 9.8794,12.7268 8.3914,12.4888",
    id: "Fill-11",
    fill: "#282827"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPersonalDetails);
export default __webpack_public_path__ + "static/media/dashboard_personal_details.d82680fb0c05b07168902250ef47a2bd.svg";
export { ForwardRef as ReactComponent };